import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.number.constructor";
import L from 'leaflet';
import { isEmpty, cloneDeep } from 'lodash';
var typhoon = {
  namespace: true,
  state: {
    typhoonInfo: [],
    // 这是完整的初始化台风数据
    typhoonCacheObj: {},
    // 台风信息对象
    checkPointInfo: {},
    // 选中的台风点
    pointsList: [],
    // 当前右侧台风信息点列表
    lightTfbh: '',
    // 高亮的台风编号
    lastPointObj: {},
    // 当前台风最后一点经纬度,有多台风情况
    typhoonCount: 0,
    // 当前台风个数
    typhoonRefresh: false // 触发刷新信号

  },
  getters: {
    getTyphoonCacheByTfbh: function getTyphoonCacheByTfbh(state) {
      return function (tfbh, type) {
        if (isEmpty(state.typhoonCacheObj)) return null;
        return type ? state.typhoonCacheObj[tfbh][type] : state.typhoonCacheObj[tfbh];
      };
    }
  },
  mutations: {
    // 设置当前选中的台风信息点
    SET_POINT_CHECK: function SET_POINT_CHECK(state, data) {
      var attentionCity = this.state.mapConfig.attentionCity;
      data.distance = L.latLng(attentionCity.lat, attentionCity.lng).distanceTo([data.lat, data.lng]); // 计算当前点与关注点距离

      data.distance = parseInt(data.distance / 1000); // console.log(L.latLng(attentionCity.lat, attentionCity.lng).distanceTo([data.lat, data.lng]))

      state.checkPointInfo = data;
    },
    // 设置高亮台风
    SET_LINGTTFBH: function SET_LINGTTFBH(state, data) {
      if (data) {
        state.lightTfbh = data;
        state.pointsList = state.typhoonCacheObj[data].points; // 拿到当前需要展示列表点
      }
    }
  },
  actions: {
    // 初始化台风数据
    initTyphoonsData: function initTyphoonsData(_ref, data) {
      var state = _ref.state,
          commit = _ref.commit;
      var number = state.typhoonCount = data.length; // if (number === 0) return;

      var attentionCity = this.state.mapConfig.attentionCity; // 拿到关注地，用于和最后一点做距离计算

      var lightTfbh = this.state.lightTfbh; // 拿到高亮的台风编号，没有默认为第一个

      var tfbhInData = false; // 高亮台风是否在台风数据上，避免配置过没有删掉

      var minDistance = Number.MAX_VALUE; // 初始化定义最短距离

      var minDistanceTfbh; // 最短距离的台风编号

      var attenCityLatlng = L.latLng([attentionCity.lat, attentionCity.lng]);
      var typhoonCacheObj = {}; // 每次更新cache要变

      data.forEach(function (val) {
        if (lightTfbh === val.tfbh) {
          tfbhInData = true;
        }

        var points = val.points;
        var length = points.length;
        val.typhoon_title = "".concat(val.ident, " ").concat(val.name, "\uFF08\u98CE\u529B").concat(points[length - 1].power, "\u7EA7\uFF09"); // 追加一个台风标题

        val.points[length - 1].yuntuanMarker = true;
        var valData = cloneDeep(val); // 这里要拷贝一份新数据，避免数据污染

        typhoonCacheObj[valData.tfbh] = valData; // 拿一份到台风数据缓存中

        var latPointLatlng = [points[length - 1].lat, points[length - 1].lng];
        state.lastPointObj[val.tfbh] = latPointLatlng;
        var distance = attenCityLatlng.distanceTo(latPointLatlng);

        if (minDistance > distance) {
          minDistance = distance;
          minDistanceTfbh = val.tfbh;
        }
      });
      state.typhoonCacheObj = typhoonCacheObj; // 转手

      var minTfbh = tfbhInData ? lightTfbh : minDistanceTfbh;
      commit('SET_LINGTTFBH', minTfbh); // 有配置且在里面用外部配置，没有用第一个
      // console.log(data, '---------------')

      state.typhoonInfo = data;
      state.typhoonRefresh = !state.typhoonRefresh; // 无台风要做个处理

      if (number === 0) {
        state.typhoonCacheObj = {}; // 台风信息对象

        state.checkPointInfo = {}; // 选中的台风点

        state.pointsList = []; // 当前右侧台风信息点列表

        state.lightTfbh = ''; // 高亮的台风编号

        state.lastPointObj = {}; // 当前台风最后一点经纬度,有多台风情况
      }

      return true;
    }
  }
};
export default typhoon;